module.exports = __webpack_public_path__ + "img/signpost.f1f34be6.svg";